<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Nagpur District Under 07-17 Boys & Girls Selection Chess Championship 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>Nagpur District Under 07-17 Boys & Girls Selection Chess Championship 2026</span></h2>
        </div>
        <p><strong>Venue:</strong> GH Raisoni College, 6th Floor, Moot Court Hall, Riaan Tower, Mangalwari, Nagpur</p>
        <p><strong>Date:</strong> 11/01/2026</p>

        <p>The <strong>Nagpur District Under 07 & Under 17 Boys and Girls Selection Chess Championship 2026</strong> was
            successfully organized on <strong>11th January 2026</strong> at <strong>GH Raisoni College</strong>, 6th
            Floor,
            Moot Court Hall, Riaan Tower, Mangalwari, Nagpur.</p>

        <p>The championship was organized by <strong>Chess Association Nagpur</strong>, in association with
            <strong>GH Raisoni Sports and Cultural Foundation</strong> and <strong>Kalpana Prakash Welfare
                Foundation</strong>.
        </p>

        <p>The event was held separately for <strong>Boys and Girls</strong> categories across <strong>Under-07 to
                Under-17 age groups</strong>, providing young chess talents a competitive platform to showcase their
            skills
            and qualify for the next level (State Level Chess Tournament).</p>
        <hr>
        <h5 class="primary-purple">Prize Money & Selection Details</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Cash Prize:</strong> ₹5,000 per category</li>
            <li><strong>Total Cash Prize Fund:</strong> ₹20,000</li>
            <li><strong>Categories:</strong> Boys (U07–U17) and Girls (U07–U17) – conducted separately</li>
            <li><strong>Selection Criteria:</strong> <strong>Top 2 players from each category</strong> (Boys & Girls)
                were selected to represent <strong>State Level</strong> in the next stage of the championship.</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Dignitaries Present:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li>Mrs. Gayatri Siriah, Assistant Commissioner, Central GST</li>
            <li>IM Anup Deshmukh</li>
            <li>Shri Bhushan Shriwas, Secretary Kalpana Prakash Welfare Foundation & Chess Association Nagpur</li>
            <li>Shri S.S Soman, Working President CAN</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Tournament Highlights:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Format:</strong> Rapid, 7 Rounds, Swiss System</li>
            <li><strong>Time Control:</strong> 15 mins + 05 sec increment per move</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Arbiter Team:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Arbiter Team Lead by:</strong> IA Shiva Iyer (Chief Arbiter)</li>
            <li><strong>Deputy & Supporting Arbiters:</strong></li>
            <li>FA Amitkumar, Mukesh Tembhurne (Deputy Chief Arbiter)</li>
            <li>NA Ambade, Prayas</li>
            <li>NA Akash, Chhaganrao Rewatkar</li>
            <li>Machave Prathamesh (Volunteer Head)</li>
        </ul>
        <hr>

        <p>The tournament witnessed enthusiastic participation, disciplined play, and high-quality competition across
            all age groups. The smooth conduct of the event reflected the excellent coordination between the organizing
            committee, arbiters, and supporting institutions.</p>

        <p>The organizers extend heartfelt thanks to all players, parents, officials, and supporting partners for
            making the championship a grand success and for promoting chess among young talents in Nagpur District.</p>
        <hr>
        <h5 class="primary-purple">Final Standing</h5>
        <div class="row row-cols-lg-2 row-cols-1">
            <div class="col">
                <p><strong>U07 Boys – Top 2:</strong></p>
                <ul class="mb-3">
                    <li>1. Reyansh Chaudhari (Tournament Winner U07 Boys)</li>
                    <li>2. Kunj Dewangan</li>
                </ul>
            </div>

            <div class="col">
                <p><strong>U07 Girls – Top 2:</strong></p>
                <ul class="mb-3">
                    <li>1. Aahi Shailesh Meshram (Tournament Winner U07 Girls)</li>
                    <li>2. Aditi Korde</li>
                </ul>
            </div>

            <div class="col">
                <p><strong>U17 Boys – Top 2:</strong></p>
                <ul class="mb-3">
                    <li>1. Sawalakhe Jay (Tournament Winner U17 Boys)</li>
                    <li>2. Aaradhya Swapnil Ubale</li>
                </ul>
            </div>

            <div class="col">
                <p><strong>U17 Girls – Top 2:</strong></p>
                <ul class="mb-3">
                    <li>1. Vritika Krushna Game (Tournament Winner U17 Girls)</li>
                    <li>2. Mishrikotkar Vidhi</li>
                </ul>
            </div>
        </div>
        <hr>
        <p>A group winner photo of the Nagpur District Under 07–17 Boys & Girls Selection Chess
            Championship 2026 was taken and preserved as a special memory of the event’s successful
            completion.</p>
        <p>The tournament was conducted smoothly, adhering to FIDE and AICF regulations.
            The response from players was overwhelming, and feedback has been highly
            positive. The Chief Arbiter appreciates the cooperation from the organizers, support
            staff, and the fair play spirit exhibited by all participants.
        </p>
        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-2.png"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-2.png">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-2.png"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-3.png"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-3.png">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-3.png"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-4.png"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-4.png">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-4.png"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Media Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-1.png"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-1.png">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-1.png"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-5.png"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-5.png">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-5.png"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-6.png"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-6.png">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/nagpur-district-6.png"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/signature-sheet.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Signature Sheet </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/under-7-17-tour-report"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Tournament Report </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
